import PageMeta from "../../components/common/PageMeta";

export default function Terms() {
  return (
    <>
      <PageMeta
        title="免責事項"
        description="ChatoraHack Lotteryの免責事項です。"
        path="/terms"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "免責事項", path: "/terms" },
        ]}
      />
      <div className="mx-auto mb-8">

        <div className="flex justify-between items-center flex-wrap mb-8 border-b border-b-2 border-primary-500 pb-2">
          <h1 className="text-2xl font-bold text-primary-500">
            免責事項
          </h1>
        </div>

        <div className="p-8 bg-base-50 rounded-3xl">
          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">情報の正確性について</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトに掲載している当選番号・［ 払戻金 ］等の情報は、公式サイトのデータをもとにしていますが、その正確性・完全性を保証するものではありません。必ず公式サイトにてご確認ください。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">投資・購入の判断について</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトの情報は宝くじの購入を推奨するものではありません。宝くじの購入はご自身の判断と責任においておこなってください。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">リンクについて</h2>
            <p className="text-gray-800 text-sm leading-relaxed">
              当サイトからリンクしている外部サイトの内容については、運営者は責任を負いかねます。
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-lg font-bold text-primary-500 mb-4">お問い合わせ</h2>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSfEAEWstoZZmx_Gyc8JL-uM-8npguBxA1b4Ul5fiqZBTq8v1Q/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-500 underline hover:no-underline text-sm"
              >
              お問い合わせフォーム
            </a>
          </section>
        </div>
      </div>
    </>
  );
}
